import type { Dispatch } from 'react';

import type { History } from 'history';
import { userLogout } from '@uncinc/react-drupal-core';
import { setNewsletterContact } from '../../store/actions/UI';

import { ROUTE_HOME } from '../../config/routes';

export default function onAccountNavMenuClick(
  history: History<unknown>,
  dispatch: Dispatch<(dispatch: any) => void>,
  { currentTarget }: React.MouseEvent<React.HTMLAttributes<HTMLDivElement>, MouseEvent>,
) {
  if (!currentTarget.className?.includes('logout')) return;
  dispatch(userLogout());
  // Clear our newsletter contact data.
  dispatch(setNewsletterContact({ data: undefined }) as any);
  history.push(ROUTE_HOME as string);
}
